<template>
  <div>
    <h1 class="text-base font-semibold text-blue-800 pb-4">Modifiers</h1>
    <div v-if="!product.modifiers.length">
      <!-- <h1 class="text-2xl font-bold text-gray-800">No tags available</h1> -->
      <!-- Create a header with small text uppercase "Product Tags" -->
      <p class="text-xs pb-4">
        Product modifiers is allowing users to customize and modify products
        based on their preferences. Product modifiers will include options such
        as size, color, and additional features that users can choose when
        purchasing a product
      </p>
      <button
        class="text-xs font-semibold text-blue-800 flex items-center gap-x-1"
        type="button"
        @click="toggleAddModal"
      >
        <img src="@/assets/tiny-plus.png" class="w-5 h-5" alt="" />
        Add Modifiers (Optional)
      </button>
    </div>

    <trac-add-modifier
      v-if="showAddModifierModal"
      :product="product"
      @close="toggleAddModal"
      @update-modifiers="updateModifier"
      @add-modifier-sets="modifierSets = $event"
    />

    <trac-dashboard-table
      v-if="false"
      :tableHeaders="tableHeaders"
      :data="product.modifiers"
    >
      <template #default="{ row }">
        <trac-dashboard-table-data>{{ row.title }}</trac-dashboard-table-data>
        <trac-dashboard-table-data>
          {{ row.description }}
        </trac-dashboard-table-data>
        <trac-dashboard-table-data>
          {{ Number(row.stockQuantity).toLocaleString() }}
        </trac-dashboard-table-data>
        <trac-dashboard-table-data>
          <button @click="removeModifier(row.id)">
            <div class="w-3 h-3">
              <img src="@/assets/svg/close-icon.svg" class="w-full h-full" />
            </div>
          </button>
        </trac-dashboard-table-data>
      </template>
    </trac-dashboard-table>

    <div v-if="product.modifiers.length" class="flex justify-end">
      <button
        class="text-xs font-semibold text-blue-800 flex items-center gap-x-1 py-6"
        type="button"
        @click="toggleAddModal"
      >
        <img src="@/assets/tiny-plus.png" class="w-5 h-5" alt="" />
        Add Modifiers
      </button>
    </div>

    <trac-dashboard-table
      v-if="modifiersSelected.length"
      :tableHeaders="modifiersHeaders"
      :data="modifiersSelected"
    >
      <template #default="{ row }">
        <trac-dashboard-table-data>{{ row.name }}</trac-dashboard-table-data>
        <trac-dashboard-table-data>
          {{ row.sellingPrice | formatPrice }}
        </trac-dashboard-table-data>
        <trac-dashboard-table-data>
          <button @click="removeModifier(row._id)">
            <div class="w-3 h-3">
              <img src="@/assets/svg/close-icon.svg" class="w-full h-full" />
            </div>
          </button>
        </trac-dashboard-table-data>
      </template>
    </trac-dashboard-table>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import { eventBus } from '../../eventBus';
export default {
  name: 'ProductModifiers',
  emits: ['update-modifiers'],
  props: {
    product: {
      type: Object,
      default: () => ({
        modifiers: [],
      }),
    },
  },
  data() {
    return {
      showAddModifierModal: false,
      loading: false,
      modifiers: [],
      modifierSets: null,
      tableHeaders: [
        {
          name: 'NAME',
        },
        {
          name: 'DETAILS',
        },
        {
          name: 'QUANTITY',
        },
        {
          name: '',
          classValue: 'w-1/6',
        },
      ],
      modifiersHeaders: [
        {
          name: 'MODIFIER',
        },
        {
          name: 'PRICE',
        },
        {
          name: '',
          classValue: 'w-1/6',
        },
      ],
    };
  },
  computed: {
    modifiersSelected() {
      return (
        this.product.modifiers?.reduce((acc, curr) => {
          const found = [...(this.modifierSets ?? [])]?.find(
            (s) => !!s.modifiers?.find((m) => m?._id === (curr?.id || curr))
          );

          if (found) {
            return [
              ...acc,
              [...found.modifiers].find((f) => f?._id === (curr?.id || curr)),
            ];
          }
          return acc;
        }, []) ?? []
      );
    },
  },
  methods: {
    ...mapActions(['FETCH_MODIFIER_SETS']),
    toggleAddModal() {
      this.showAddModifierModal = !this.showAddModifierModal;
    },
    updateModifier(data) {
      const allModifiers = [
        // ...this.product.modifiers?.map((m) => m?.id || m),
        ...data,
      ];
      const uniqueModifiers = Array.from(
        new Set(allModifiers.map((mod) => mod?.id || mod))
      ).map((id) => allModifiers.find((mod) => (mod?.id || mod) === id));

      this.$emit('update-modifiers', uniqueModifiers);
      this.toggleAddModal();
    },
    removeModifier(id) {
      this.$emit(
        'update-modifiers',
        this.product.modifiers.filter((mod) => (mod?.id || mod) !== id)
      );
    },
    async fetchModifierSets() {
      try {
        const res = await this.FETCH_MODIFIER_SETS();
        this.modifierSets = (res.data ?? []).filter((mod) => !!mod.modifiers);
      } catch (error) {
        eventBus.$emit('trac-alert', {
          message: error?.res?.data?.message || error?.message,
        });
      }
    },
  },
  watch: {
    product: {
      deep: true,
      immediate: true,
      handler(val) {
        if (val.id && !this.modifierSets) {
          this.fetchModifierSets();
        }
      },
    },
  },
};
</script>

<style lang="scss" scoped></style>
